import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Button
} from 'reactstrap';
import Grid from '../../components/Grid';
import ConfirmDialog from '../../components/ConfirmDialog';
import {listPaginatedHotelsUsingQuery as APIListPaginatedProperties} from '../../gateways/properties';
import {deleteProperty as APIDeleteProperties} from '../../gateways/properties';

class PropertyList extends Component {

  constructor(props) {
    super(props);
  
    let currentPage = 1;
    this.state = {
      data: [],
      currentPage: currentPage,
      total: 0,
      limit: 20,
      filters: {
        userId: this.props.userProfile.id
      },
      submitModalOpen: false,
      deleteProperty: null
    };

    console.log('I:--START--:--OnLoad Property List--:userProfile/', this.props.userProfile);

    this.onSubmitFilters = this.onSubmitFilters.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.submitModalToggle = this.submitModalToggle.bind(this);
    this.showModal = this.showModal.bind(this);
    this.onDeleteItem = this.onDeleteItem.bind(this);
  }

  submitModalToggle() {
    this.setState({
      submitModalOpen: !this.state.submitModalOpen
    });
  }

  fetchData() {
    APIListPaginatedProperties({ limit: this.state.limit, page: this.state.currentPage, ...this.state.filters })
    .then(result => {
      this.setState({
        data: result.data.properties,
        maxPage: result.pages,
        total: result.total
      });
    });
  }

  componentWillMount() {
    this.fetchData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isListUpdated) {
      this.fetchData();
      this.setState(nextProps);
      this.props.changePropertiesState();
    }
   }

  getGridButtons(item) {
    return (
      <div>
        <Button size="sm" color="primary" onClick={e => this.props.onEditPropertyClick(e, item)}>
          <i className="fa fa-pencil"></i>
        </Button>{' '}
        <Button size="sm" color="primary" onClick={e => this.showModal(e, item)}>
          <i className="fa fa-trash"></i>
        </Button>
      </div>
    );
  }

  onChangePage(page) {
    this.setState({
      currentPage: page
    }, this.fetchData);
  }

  onSubmitFilters(filters) {
    this.setState({
      currentPage: 1,
      filters: {
        ...this.state.filters,
        ...filters
      }
    }, this.fetchData);
  }

  showModal(e, item) {
    e.preventDefault();
    this.setState({
      deleteProperty: item
    });
    this.submitModalToggle();
  }

  onDeleteItem(answer, property) {
    if (answer === 'Y' && property) {
      APIDeleteProperties(property.id).then(result => {
        if (!result.error) {
          this.submitModalToggle();
          this.setState({ deleteProperty: null });
          this.fetchData();
        }
      });
    } else if (answer === 'N') {
      this.submitModalToggle();
      this.setState({ deleteProperty: null });
    }
  }

  render() {
    let columns = [
      {
        key: "idx",
        type: "string",
        name: "No.",
        minWidth: "50px"
      },
      {
        key: "propertyName",
        type: "string",
        name: "Property Name",
        minWidth: "150px"
      },
      {
        key: "propertyAddress",
        type: "string",
        name: "Property Address",
        minWidth: "150px"
      },
      {
        key: "tools",
        type: "custom",
        render: (row) => this.getGridButtons(row)
      },
    ];

    return (
      <Card>
        <CardHeader>
          <strong>Properties</strong>
        </CardHeader>
        <CardBody>
          <div className="animated fadeIn">
            <Row>
              <Col xs="12">
                <Grid
                  columns={columns}
                  onSubmitFilters={this.onSubmitFilters}
                  onChangePage={this.onChangePage}
                  data={this.state.data}
                  currentPage={this.state.currentPage}
                  total={this.state.total}
                  perPage={this.state.limit} />
              </Col>
            </Row>
          </div>
        </CardBody>
        <CardFooter>
          <Button size="sm" color="primary" onClick={e => this.props.onCreatePropertyClick(e)}>
            New Property
          </Button>
          <ConfirmDialog isOpen={this.state.submitModalOpen}
            toggle={this.submitModalToggle}
            title={"Message"}
            body={"Confirm delete item?"}
            size={"xs"}
            callback={this.onDeleteItem}
            item={this.state.deleteProperty} />
        </CardFooter>
      </Card>
    ) 
  }
} 

export { PropertyList };


// WEBPACK FOOTER //
// ./src/components/PropertyList/PropertyList.js